/* eslint-disable no-template-curly-in-string */
import { Rule } from 'antd/lib/form'
import type { ValidateMessages } from 'rc-field-form/lib/interface'

export const required = { required: true }
export const validateMessages: ValidateMessages = {
  required: '${label} is required',
  pattern: {
    mismatch: '${label} is not valid',
  },
  types: {
    email: 'email is not valid',
  },
}

export const passwordRule: Rule = {
  required: true,
  pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,30}$/,
}

export const phraseRule: Rule = { min: 3, max: 30, type: 'string', message: 'Security phase must be between 3 to 30 characters.' }

export const usernameRule: Rule = {
  required: true,
  pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[A-Za-z\d$@$!%*#?&//-/_/./^]{8,30}$/,
}

export const IDRule: Rule = {
  required: true,
  pattern: /^\d{6}-\d{2}-\d{4}$/,
}